var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-layout-footer"},[_c('section',{staticClass:"app-layout-footer-global"},[_c('div',{staticClass:"footer-copyright"},[_vm._v(_vm._s(_vm.copyright))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }